import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { ViewHotels } from '../pages/hotelmanagement/ViewHotels'
import { AddHotelBasicInfo } from '../pages/hotelmanagement/AddHotelBasicInfo'
import { HotelOverview } from '../pages/hotelmanagement/HotelOverview'
import { ViewRooms } from '../pages/hotelmanagement/ViewRooms'
import { ViewRestaurant } from '../pages/restaurantmanagement/ViewRestaurant'
import { AddRestaurantBasicInfo } from '../pages/restaurantmanagement/AddRestaurantBasicInfo'
import { ViewSpaceRental } from '../pages/spacerentalmanagement/ViewSpaceRental'
import { SpaceRentalOverview } from '../pages/spacerentalmanagement/SpaceRentalOverview'
import { ViewRentableSpaces } from '../pages/spacerentalmanagement/ViewRentableSpaces'
import { ViewTourPackages } from '../pages/tourpackagemanagement/ViewTourPackages'
import { RestaurantOverview } from '../pages/restaurantmanagement/RestaurantOverview'
import { TourPackageOverview } from '../pages/tourpackagemanagement/TourPackageOverview'
import { RentableSpaceOverview } from '../pages/spacerentalmanagement/RentableSpaceOverview'
import { RoomOverview } from '../pages/hotelmanagement/RoomOverview'
import { ViewCarRentals } from '../pages/carrentalmanagement/ViewCarRentals'
import { AddCarRentalBasicInfo } from '../pages/carrentalmanagement/AddCarRentalBasicInfo'
import { AddHotelLocation } from '../pages/hotelmanagement/AddHotelLocation'
import { AddHotelDetails } from '../pages/hotelmanagement/AddHotelDetails'
import { AddHotelPhotos } from '../pages/hotelmanagement/AddHotelPhotos'
import { AddHotelFacilities } from '../pages/hotelmanagement/AddHotelFacilities'
import { AddHotelPolicies } from '../pages/hotelmanagement/AddHotelPolicies'
import { AddHotelFinance } from '../pages/hotelmanagement/AddHotelFinance'
import { ViewRoomsList } from '../pages/hotelmanagement/ViewRoomsList'
import { AddRestaurantLocation } from '../pages/restaurantmanagement/AddRestaurantLocation'
import { AddRestaurantDetails } from '../pages/restaurantmanagement/AddRestaurantDetails'
import { AddRestaurantPhotos } from '../pages/restaurantmanagement/AddRestaurantPhotos'
import { AddRestaurantFacilities } from '../pages/restaurantmanagement/AddRestaurantFacilities'
import { AddRestaurantPolicies } from '../pages/restaurantmanagement/AddRestaurantPolicies'
import { AddRestaurantFinance } from '../pages/restaurantmanagement/AddRestaurantFinance'
import { AddRestaurantMenu } from '../pages/restaurantmanagement/AddRestaurantMenu'
import { AddSpaceBasicInfo } from '../pages/spacerentalmanagement/AddSpaceBasicInfo'
import { AddSpaceLocation } from '../pages/spacerentalmanagement/AddSpaceLocation'
import { AddSpaceDetails } from '../pages/spacerentalmanagement/AddSpaceDetails'
import { AddSpacePhotos } from '../pages/spacerentalmanagement/AddSpacePhotos'
import { AddSpaceFacilities } from '../pages/spacerentalmanagement/AddSpaceFacilities'
import { AddSpaceAvailability } from '../pages/spacerentalmanagement/AddSpaceAvailability'
import { AddSpacePolicies } from '../pages/spacerentalmanagement/AddSpacePolicies'
import { AddSpaceFinance } from '../pages/spacerentalmanagement/AddSpaceFinance'
import { AddRestaurantAvailability } from '../pages/restaurantmanagement/AddRestaurantAvailability'
import { ViewRentableSpaceList } from '../pages/spacerentalmanagement/ViewRentableSpaceList'
import { AddTourPackageBasicInfo } from '../pages/tourpackagemanagement/AddTourPackageBasicInfo'
import { AddTourPackageLocation } from '../pages/tourpackagemanagement/AddTourPackageLocation'
import { AddTourPackagePhotos } from '../pages/tourpackagemanagement/AddTourPackagePhotos'
import { AddTourPackagePolicies } from '../pages/tourpackagemanagement/AddTourPackagePolicies'
import { AddTourPackageFinance } from '../pages/tourpackagemanagement/AddTourPackageFinance'
import { ViewTours } from '../pages/tourpackagemanagement/ViewTours'
import { ToursOverview } from '../pages/tourpackagemanagement/ToursOverview'
import { AddCarRentalLocation } from '../pages/carrentalmanagement/AddCarRentalLocation'
import { AddCarRentalPhotos } from '../pages/carrentalmanagement/AddCarRentalPhotos'
import { AddCarRentalFinance } from '../pages/carrentalmanagement/AddCarRentalFinance'
import { ViewCars } from '../pages/carrentalmanagement/ViewCars'
import { AddCarRentalInsurance } from '../pages/carrentalmanagement/AddCarRentalInsurance'
import { AddCarRentalAvailability } from '../pages/carrentalmanagement/AddCarRentalAvailability'
import { AddCarRentalPickupOrDropoffInfo } from '../pages/carrentalmanagement/AddCarRentalPickupOrDropoffInfo'
import { AddCarRentalDocuments } from '../pages/carrentalmanagement/AddCarRentalDocuments'
import { AddCarRentalPolicies } from '../pages/carrentalmanagement/AddCarRentalPolicies'
import { VehicleOverview } from '../pages/carrentalmanagement/VehicleOverview'
import { CarRentalOverview } from '../pages/carrentalmanagement/CarRentalOverview'
import { ViewCarsList } from '../pages/carrentalmanagement/ViewCarsList'
import { ViewToursList } from '../pages/tourpackagemanagement/ViewToursList'
import { ViewHotelBooking } from '../pages/hotelmanagement/booking/ViewHotelBooking'
import { ViewHotelBookingDetails } from '../pages/hotelmanagement/booking/ViewHotelBookingDetails'
import { ViewSpaceRentalBooking } from '../pages/spacerentalmanagement/booking/ViewSpaceRentalBooking'
import { ViewSpaceBookingDetails } from '../pages/spacerentalmanagement/booking/ViewSpaceBookingDetails'
import { ViewTourPackageBooking } from '../pages/tourpackagemanagement/booking/ViewTourPackageBooking'
import { ViewTourBookingDetails } from '../pages/tourpackagemanagement/booking/ViewTourBookingDetails'
import { ViewCarRentalBooking } from '../pages/carrentalmanagement/booking/ViewCarRentalBooking'
import { ViewCarBookingDetails } from '../pages/carrentalmanagement/booking/ViewCarBookingDetails'
import { ViewLoyaltyProgram } from '../pages/promotionanddiscounts/loyaltyprogram/ViewLoyaltyProgram'
import { ViewHotelCouponList } from '../pages/hotelmanagement/couponmanagement/ViewHotelCouponList'
import { AddHotelCoupon } from '../pages/hotelmanagement/couponmanagement/AddHotelCoupon'
import { ViewSpaceCouponList } from '../pages/spacerentalmanagement/couponmanagement/ViewSpaceCouponList'
import { AddSpaceCoupon } from '../pages/spacerentalmanagement/couponmanagement/AddSpaceCoupon'
import { AddTourCoupon } from '../pages/tourpackagemanagement/couponmanagement/AddTourCoupon'
import { ViewTourCouponList } from '../pages/tourpackagemanagement/couponmanagement/ViewTourCouponList'
import { AddCarCoupon } from '../pages/carrentalmanagement/couponmanagement/AddCarCoupon'
import { ViewCarCouponList } from '../pages/carrentalmanagement/couponmanagement/ViewCarCouponList'
import { ViewHotelInventory } from '../pages/hotelmanagement/inventorymanagamant/ViewHotelInventory'
import { ViewSpaceInventory } from '../pages/spacerentalmanagement/inventorymanagamant/ViewSpaceInventory'
import { ViewTourInventory } from '../pages/tourpackagemanagement/inventorymanagamant/ViewTourInventory'
import { ViewCarInventory } from '../pages/carrentalmanagement/inventorymanagamant/ViewCarInventory'
import { OccuepancyReport } from '../pages/reportmanagement/OccuepancyReport'
import { GuestReport } from '../pages/reportmanagement/GuestReport'
import { CouponReport } from '../pages/reportmanagement/CouponReport'
import { FinancialReport } from '../pages/reportmanagement/FinancialReport'
import { ViewRevenueList } from '../pages/revenuemanagement/ViewRevenueList'
import { ViewHotelCancelledBooking } from '../pages/hotelmanagement/booking/ViewHotelCancelledBooking'
import { ViewSpaceCancelledBooking } from '../pages/spacerentalmanagement/booking/ViewSpaceCancelledBooking'
import { ViewTourCancelledBooking } from '../pages/tourpackagemanagement/booking/ViewTourCancelledBooking'
import { ViewHelpAndSupport } from '../pages/helpandsupportmanagement/ViewHelpAndSupport'
import { AddHelpAndSupport } from '../pages/helpandsupportmanagement/AddHelpAndSupport'
import { ViewRatingAndReviewBookingWise } from '../pages/feedbackandreviews/ViewRatingAndReviewBookingWise'
import { ViewCarCancelledBooking } from '../pages/carrentalmanagement/booking/ViewCarCancelledBooking'
import { ViewHotelContract } from '../pages/hotelmanagement/ViewHotelContract'
import { ViewSpaceContract } from '../pages/spacerentalmanagement/ViewSpaceContract'
import { ViewRestaurantContract } from '../pages/restaurantmanagement/ViewRestaurantContract'
import { ViewTourContract } from '../pages/tourpackagemanagement/ViewTourContract'
import { ViewCarContract } from '../pages/carrentalmanagement/ViewCarContract'
import ViewContact from '../pages/helpandsupportmanagement/ViewContact'

const PrivateRoutes = () => {
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='dashboard' element={<DashboardWrapper />} />

        {/* beggin::hotel routes */}
        <Route path='addhotelbasicinfo' element={<AddHotelBasicInfo />} />
        <Route path='addhotellocation' element={<AddHotelLocation />} />
        <Route path='addhoteldetails' element={<AddHotelDetails />} />
        <Route path='hoteloverview' element={<HotelOverview />} />
        <Route path='viewrooms' element={<ViewRooms />} />
        <Route path='viewroomslist' element={<ViewRoomsList />} />
        <Route path='addhotelphotos' element={<AddHotelPhotos />} />
        <Route path='addhotelfacilities' element={<AddHotelFacilities />} />
        <Route path='addhotelpolicies' element={<AddHotelPolicies />} />
        <Route path='addhotelfinance' element={<AddHotelFinance />} />
        <Route path='viewhotels' element={<ViewHotels />} />
        <Route path='roomoverview' element={<RoomOverview />} />
        <Route path='viewhotelbooking' element={<ViewHotelBooking />} />
        <Route path='viewhotelbookingdetails' element={<ViewHotelBookingDetails />} />
        <Route path='viewhotelcancelledbooking' element={<ViewHotelCancelledBooking />} />
        <Route path='viewhotelcontract' element={<ViewHotelContract />} />
        {/* end::hotel routes */}
        
        {/* beggin::restaurant routes */}
        <Route path='addrestaurantbasicinfo' element={<AddRestaurantBasicInfo />} />
        <Route path='addrestaurantlocation' element={<AddRestaurantLocation />} />
        <Route path='addrestaurantdetails' element={<AddRestaurantDetails />} />
        <Route path='addrestaurantphotos' element={<AddRestaurantPhotos />} />
        <Route path='addrestaurantfacilities' element={<AddRestaurantFacilities />} />
        <Route path='addrestaurantpolicies' element={<AddRestaurantPolicies />} />
        <Route path='addrestaurantfinance' element={<AddRestaurantFinance />} />
        <Route path='addrestaurantmenu' element={<AddRestaurantMenu />} />
        <Route path='restaurantoverview' element={<RestaurantOverview />} />
        <Route path='addrestaurantavailability' element={<AddRestaurantAvailability />} />
        <Route path='viewrestaurants' element={<ViewRestaurant />} />
        <Route path='viewrestaurantcontract' element={<ViewRestaurantContract />} />
        {/* end:: restaurant routes */}

        {/* beggin:: space rental routes */}
        <Route path='addspacebasicinfo' element={<AddSpaceBasicInfo />} />
        <Route path='addspacelocation' element={<AddSpaceLocation />} />
        <Route path='addspacedetails' element={<AddSpaceDetails />} />
        <Route path='addspacephotos' element={<AddSpacePhotos />} />
        <Route path='addspacefacilities' element={<AddSpaceFacilities />} />
        <Route path='addspaceavailability' element={<AddSpaceAvailability />} />
        <Route path='addspacepolicies' element={<AddSpacePolicies />} />
        <Route path='addspacefinance' element={<AddSpaceFinance />} />
        <Route path='viewrentablespaces' element={<ViewRentableSpaces />} />
        <Route path='viewrentablespacelist' element={<ViewRentableSpaceList />} />
        <Route path='rentablespaceoverview' element={<RentableSpaceOverview />} />
        <Route path='viewspacerentals' element={<ViewSpaceRental />} />
        <Route path='spacerentaloverview' element={<SpaceRentalOverview />} />
        <Route path='viewspacerentalbooking' element={<ViewSpaceRentalBooking />} />
        <Route path='viewspacebookingdetails' element={<ViewSpaceBookingDetails />} />
        <Route path='viewspacecancelledbooking' element={<ViewSpaceCancelledBooking />} />
        <Route path='viewspacecontract' element={<ViewSpaceContract />} />
        {/* end:: space rental routes */}

        {/* beggin:: tour package routes */}
        <Route path='addtourpackagebasicinfo' element={<AddTourPackageBasicInfo />} />
        <Route path='addtourpackagelocation' element={<AddTourPackageLocation />} />
        <Route path='addtourpackagephotos' element={<AddTourPackagePhotos />} />
        <Route path='addtourpackagepolicies' element={<AddTourPackagePolicies />} />
        <Route path='addtourpackagefinance' element={<AddTourPackageFinance />} />
        <Route path='viewtours' element={<ViewTours />} />
        <Route path='toursoverview' element={<ToursOverview />} />
        <Route path='viewtourslist' element={<ViewToursList />} />
        <Route path='viewtourpackages' element={<ViewTourPackages />} />
        <Route path='tourpackageoverview' element={<TourPackageOverview />} />
        <Route path='viewtourpackagebooking' element={<ViewTourPackageBooking />} />
        <Route path='viewtourbookingdetails' element={<ViewTourBookingDetails />} />
        <Route path='viewtourcancelledbooking' element={<ViewTourCancelledBooking />} />
        <Route path='viewtourcontract' element={<ViewTourContract />} />
        {/* end:: tour package routes */}
        
        {/* beggin:: car rental routes */}
        <Route path='addcarrentalbasicinfo' element={<AddCarRentalBasicInfo />} />
        <Route path='addcarrentallocation' element={<AddCarRentalLocation />} />
        <Route path='addcarrentalphotos' element={<AddCarRentalPhotos />} />
        <Route path='addcarrentalfinance' element={<AddCarRentalFinance />} />
        <Route path='viewcars' element={<ViewCars />} />
        <Route path='addcarrentalinsurance' element={<AddCarRentalInsurance />} />
        <Route path='addcarrentalavailability' element={<AddCarRentalAvailability />} />
        <Route path='addcarrentalpickupordropoffinfo' element={<AddCarRentalPickupOrDropoffInfo />} />
        <Route path='addcarrentaldocuments' element={<AddCarRentalDocuments />} />
        <Route path='addcarrentalpolicies' element={<AddCarRentalPolicies />} />
        <Route path='viewcarrentals' element={<ViewCarRentals />} />
        <Route path='vehicleoverview' element={<VehicleOverview />} />
        <Route path='carrentaloverview' element={<CarRentalOverview />} />
        <Route path='viewcarslist' element={<ViewCarsList />} />
        <Route path='viewcarrentalbooking' element={<ViewCarRentalBooking />} />
        <Route path='viewcarbookingdetails' element={<ViewCarBookingDetails />} />
        <Route path='viewcarcancelledbooking' element={<ViewCarCancelledBooking />} />
        <Route path='viewcarcontract' element={<ViewCarContract />} />
        {/* end:: car rental routes */}

        {/* beggin:: promotion & discount*/}
        <Route path='viewloyaltyprogram' element={<ViewLoyaltyProgram />} />
        <Route path='viewhotelcouponlist' element={<ViewHotelCouponList />} />
        <Route path='addhotelcoupon' element={<AddHotelCoupon />} />
        <Route path='viewspacecouponlist' element={<ViewSpaceCouponList />} />
        <Route path='addspacecoupon' element={<AddSpaceCoupon />} />
        <Route path='addtourcoupon' element={<AddTourCoupon />} />
        <Route path='viewtourcouponlist' element={<ViewTourCouponList />} />
        <Route path='addcarcoupon' element={<AddCarCoupon />} />
        <Route path='viewcarcouponlist' element={<ViewCarCouponList />} />
        {/* end:: promotion & discount*/}

        {/* beggin:: Inventory Management */}
        <Route path='viewhotelinventory' element={<ViewHotelInventory />} />
        <Route path='viewspaceinventory' element={<ViewSpaceInventory />} />
        <Route path='viewtourinventory' element={<ViewTourInventory />} />
        <Route path='viewcarinventory' element={<ViewCarInventory />} />
        {/* end:: Inventory Management */}

        {/* beggin:: Invoice Management */}
        <Route path='occupancyreport' element={<OccuepancyReport />} />
        <Route path='guestreport' element={<GuestReport />} />
        <Route path='couponreport' element={<CouponReport />} />
        <Route path='financialreport' element={<FinancialReport />} />
        {/* end:: Invoice Management */}

        {/* beggin:: Revenue Management */}
        <Route path='viewrevenuelist' element={<ViewRevenueList />} />
        {/* end:: Revenue Management */}

        {/* beggin:: Help & Support Management */}
        <Route path='viewhelpandsupport' element={<ViewHelpAndSupport />} />
        <Route path='addhelpandsupport' element={<AddHelpAndSupport />} />
        <Route path='contactus' element={<ViewContact />} />
        {/* <Route path='communication' element={<ViewCommunication />} /> */}
        {/* end:: Help & Support Management */}

        {/* beggin:: Feedback & Review Management */}
        <Route path='viewratingandreviewbookingwise' element={<ViewRatingAndReviewBookingWise />} />
        {/* end:: Feedback & Review Management */}

        {/* Lazy Modules */}
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
